module.exports = __webpack_public_path__ + "whitesalad.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whitesalad.png
// module id = 901
// module chunks = 0